export default "<p>event-create works!</p>\n"